<template>
  <a v-if="props.circleId != null && Boolean(props.hasImg)">
    <img :src="imgUrl" :alt="props.circleName">
  </a>
  <a v-else-if="props.circleId != null && !Boolean(props.hasImg)">
    <img :src="nonCircleIcon" :alt="props.circleName">
  </a>
</template>
<script setup>
import { computed, defineProps } from 'vue';
import Common from '../../js/common.js';
import Global from '../../js/constant.js';

const props = defineProps({
  hasImg : {
    type : Boolean,
    required: true
  },
  circleId : {
    type : Number,
    required : false
  },
  circleName : {
    type : String,
    required : false
  },
})

const imgUrl = computed(() => `/app/images/circle/${props.circleId}`)
const nonCircleIcon = computed(() => `${Common.getBaseUrl()}${Global.static_path}/images/common/circle_icon.png`)
</script>